<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-8">
      
      <!-- Loading State -->
      <div *ngIf="isLoading" class="text-center">
        <div class="card shadow-sm border-0">
          <div class="card-body p-5">
            <div class="spinner-border text-primary mb-3" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
            <h4 class="text-muted">Procesando invitación...</h4>
            <p class="text-muted">Por favor espere mientras verificamos la información.</p>
          </div>
        </div>
      </div>

      <!-- Invitation Details (shown after loading) -->
      <div *ngIf="!isLoading && isAuthenticated && invitationInfo" class="text-center">
        <div class="card shadow-lg border-0">
          <div class="card-header bg-primary text-white">
            <h3 class="card-title mb-0">
              <i class="fas fa-envelope-open-text me-2"></i>
              Invitación a Videoteca
            </h3>
          </div>
          
          <div class="card-body p-5">
            <!-- Videoteca Information -->
            <div class="mb-4">
              <i class="fas fa-video text-primary" style="font-size: 3rem;"></i>
              <h4 class="mt-3 mb-2">{{ videotecaInfo?.title || videotecaInfo?.name || 'Videoteca' }}</h4>
              <p class="text-muted" *ngIf="videotecaInfo?.description">
                {{ videotecaInfo.description }}
              </p>
            </div>

            <!-- User Information -->
            <div class="alert alert-light border-0 mb-4">
              <div class="row align-items-center">
                <div class="col-md-3">
                  <i class="fas fa-user-circle text-muted" style="font-size: 2.5rem;"></i>
                </div>
                <div class="col-md-9 text-start">
                  <h6 class="mb-1">Usuario invitado:</h6>
                  <p class="mb-0 fw-bold">{{ currentUser?.email }}</p>
                  <small class="text-muted">{{ currentUser?.firstName }} {{ currentUser?.lastName }}</small>
                </div>
              </div>
            </div>

            <!-- Invitation Actions -->
            <div class="d-grid gap-2 d-md-flex justify-content-md-center">
              <button 
                type="button" 
                class="btn btn-success btn-lg px-4"
                (click)="acceptInvitation()">
                <i class="fas fa-check me-2"></i>
                Aceptar Invitación
              </button>
              
              <button 
                type="button" 
                class="btn btn-outline-secondary btn-lg px-4"
                (click)="declineInvitation()">
                <i class="fas fa-times me-2"></i>
                Rechazar
              </button>
            </div>

            <!-- Additional Information -->
            <div class="mt-4">
              <small class="text-muted">
                <i class="fas fa-info-circle me-1"></i>
                Al aceptar esta invitación, tendrás acceso completo a todos los contenidos de la videoteca.
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="!isLoading && !invitationInfo && isAuthenticated" class="text-center">
        <div class="card shadow-sm border-danger">
          <div class="card-body p-5">
            <i class="fas fa-exclamation-triangle text-danger" style="font-size: 3rem;"></i>
            <h4 class="text-danger mt-3">Invitación No Válida</h4>
            <p class="text-muted">
              La invitación no existe, ha expirado o ya fue utilizada.
            </p>
            <button 
              type="button" 
              class="btn btn-primary"
              (click)="goToDashboard()">
              <i class="fas fa-home me-2"></i>
              Ir al Dashboard
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>